import React, { useState } from 'react';
import { Study } from '../StudyList';
import styles from './StudyTags.module.scss';
import { Inline } from 'components/layout';
import { Tag } from 'components/core/Tag/Tag';
import { Icon, IconList } from 'components/core';

type Props = {
  tags: Study['tags'];
  removeTag?: (tag: any) => Promise<void>;
};

const TagWithDelete = (props: {
  removeTag: Props['removeTag'];
  name: string;
}) => {
  const { name, removeTag } = props;

  const [isLoading, setIsLoading] = useState(false);
  return (
    <Tag
      component="li"
      isLoading={isLoading}
      onRemove={async () => {
        if (!removeTag) return;
        setIsLoading(true);

        try {
          await removeTag(name);
        } catch {
          setIsLoading(false);
        }
      }}
      dataPendoKey="remove-tag-button"
      data-testid="study-tag"
    >
      {name}
    </Tag>
  );
};

export const StudyTags = (props: Props) => {
  const { tags = [], removeTag = () => Promise.resolve() } = props;

  if (tags.length === 0) return null;

  return (
    <Inline alignX="left" alignY="top" spacing={2} shouldWrap={false}>
      <Icon
        variant="neutral"
        size="xl"
        aria-label="Study tags:"
        icon={IconList.light.faTag}
        className={styles.tagIcon}
      />
      <Inline
        alignX="left"
        spacing={2}
        component="ul"
        className={styles.tagList}
        data-testid="study-tags"
      >
        {tags.map((tag) => {
          return (
            <TagWithDelete
              key={`tag-${tag}`}
              name={tag}
              removeTag={removeTag}
            />
          );
        })}
      </Inline>
    </Inline>
  );
};
